import { Divider } from '@mui/material';
import classNames from 'classnames';
import { toString } from 'lodash-es';
import type { ReactNode } from 'react';
import { LogicalDeviceConnectivityInfo } from '../logical-device-connectivity-info/LogicalDeviceConnectivityInfo.ctrl';
import type { LogicalDeviceConnectivityInfoParams } from '../logical-device-connectivity-info/logicalDeviceConnectivityInfo.model';
import styles from './logicalDeviceConnectivityInfoGroup.module.scss';

export interface LogicalDeviceConnectivityInfoGroupParams {
  readonly group: LogicalDeviceConnectivityInfoParams[];
  readonly componentsClassNames?: Partial<Record<'container' | 'divider' | 'item', string>>;
}

export function LogicalDeviceConnectivityInfoGroup({
  group,
  componentsClassNames,
}: LogicalDeviceConnectivityInfoGroupParams): ReactNode {
  const GROUP_LENGTH = 4;
  return (
    <div
      className={classNames(styles.container, toString(componentsClassNames?.container), {
        [styles.container__multiple]: group.length >= GROUP_LENGTH,
      })}
    >
      {group.map(({ icon, label, key, iconColor, tooltip, subtitle }, idx) => (
        <>
          <div
            className={classNames(
              styles.item,
              { [styles.item__first]: idx === 0, [styles.item__last]: idx === group.length - 1 },
              toString(componentsClassNames?.item),
            )}
            key={`${key}-div-${idx + 1}`}
          >
            <div className={styles.item__wrapper} key={`${key}-subdiv-${idx + 1}`}>
              <LogicalDeviceConnectivityInfo
                icon={icon}
                iconColor={iconColor}
                key={`${key}${idx + 1}`}
                label={label}
                subtitle={subtitle}
                tooltip={tooltip}
              />
            </div>
          </div>
          {idx < group.length - 1 ? (
            <Divider
              className={classNames(styles.separator, toString(componentsClassNames?.divider))}
              flexItem
              key={`${key}-divider-${idx + 1}`}
              orientation="vertical"
            />
          ) : undefined}
        </>
      ))}
    </div>
  );
}
